import React from 'react';
import useLanguage from '../hooks/useLanguage';
import ContactForm from '../components/contact/ContactForm';
import ContactInfo from '../components/contact/ContactInfo';

/**
 * Contact Page
 * Displays contact form and contact information
 */
const Contact = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Page Header */}
      <section className="bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 text-white py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            {language === 'ko' ? '문의하기' : 'Contact Us'}
          </h1>
          <p className="text-lg md:text-xl text-blue-100 max-w-2xl mx-auto">
            {language === 'ko'
              ? '궁금하신 점이 있으시면 언제든지 연락주세요. 빠르게 답변드리겠습니다.'
              : 'If you have any questions, please feel free to contact us. We will respond promptly.'}
          </p>
        </div>
      </section>

      {/* Contact Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {/* 2-Column Layout: Form (left) + Info (right) on desktop, Stack on mobile */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
            {/* Contact Form */}
            <div className="bg-white p-6 md:p-8 rounded-lg shadow-lg">
              <ContactForm />
            </div>

            {/* Contact Information */}
            <div className="bg-white p-6 md:p-8 rounded-lg shadow-lg">
              <ContactInfo />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
